import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CadastroBody from '../components/aluno';
function Cadastro(){
    return(
        <div>
            <Header/>
            <CadastroBody/>
        </div>
    );
}
export default Cadastro;